import { runningInRNWebView, postMessageRN, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';
export default async (textToCopy) => {
    if (!textToCopy)
        return;
    if (runningInRNWebView) {
        postMessageRN({
            action: WebToRNAction.COPY_TEXT,
            payload: textToCopy,
        });
    }
    else {
        try {
            await navigator.clipboard.writeText(textToCopy);
        }
        catch (_) {
            const type = 'text/plain';
            const blob = new Blob([textToCopy], { type });
            const data = [new ClipboardItem({ [type]: blob })];
            await navigator.clipboard.write(data);
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi91dGlscy9zcmMvQ29weVRvQ2xpcGJvYXJkL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxhQUFhLEVBQUUsYUFBYSxFQUFFLE1BQU0sbUNBQW1DLENBQUM7QUFFckcsZUFBZSxLQUFLLEVBQUUsVUFBbUIsRUFBRSxFQUFFO0lBQ3pDLElBQUksQ0FBQyxVQUFVO1FBQUUsT0FBTztJQUN4QixJQUFJLGtCQUFrQixFQUFFLENBQUM7UUFDckIsYUFBYSxDQUFDO1lBQ1YsTUFBTSxFQUFFLGFBQWEsQ0FBQyxTQUFTO1lBQy9CLE9BQU8sRUFBRSxVQUFVO1NBQ3RCLENBQUMsQ0FBQztJQUNQLENBQUM7U0FBTSxDQUFDO1FBQ0osSUFBSSxDQUFDO1lBQ0QsTUFBTSxTQUFTLENBQUMsU0FBUyxDQUFDLFNBQVMsQ0FBQyxVQUFVLENBQUMsQ0FBQztRQUNwRCxDQUFDO1FBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztZQUNULE1BQU0sSUFBSSxHQUFHLFlBQVksQ0FBQztZQUMxQixNQUFNLElBQUksR0FBRyxJQUFJLElBQUksQ0FBQyxDQUFDLFVBQVUsQ0FBQyxFQUFFLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQztZQUM5QyxNQUFNLElBQUksR0FBRyxDQUFDLElBQUksYUFBYSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDLENBQUM7WUFDbkQsTUFBTSxTQUFTLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUMxQyxDQUFDO0lBQ0wsQ0FBQztBQUNMLENBQUMsQ0FBQyJ9